import React from 'react';

export function FileExclamation({ color }: { color: 'red' | 'blue' }) {
  const fill = color === 'red' ? '#DC2626' : '#1E40AF';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
      <path
        d="M12.7252 4.1502L9.2752 0.750195C9.0752 0.550195 8.8002 0.450195 8.5252 0.450195H2.5252C1.6752 0.450195 0.950195 1.1502 0.950195 2.0252V14.0252C0.950195 14.8752 1.6502 15.6002 2.5252 15.6002H11.4502C12.3002 15.6002 13.0252 14.9002 13.0252 14.0252V4.9002C13.0252 4.6252 12.9252 4.3502 12.7252 4.1502ZM9.3002 2.3502L11.1752 4.2002H9.3002V2.3502ZM11.4752 14.4502H2.5252C2.2752 14.4502 2.0752 14.2502 2.0752 14.0002V2.0002C2.0752 1.7502 2.2752 1.5502 2.5252 1.5502H8.1752V4.7502C8.1752 5.0502 8.4252 5.3252 8.7502 5.3252H11.9252V14.0002C11.9002 14.2502 11.7002 14.4502 11.4752 14.4502Z"
        fill={fill}
      />
      <path
        d="M6.7498 6.1001C6.4498 6.1001 6.1748 6.3501 6.1748 6.6751V10.0501C6.1748 10.3501 6.4248 10.6251 6.7498 10.6251C7.0748 10.6251 7.2998 10.3751 7.2998 10.0501V6.6501C7.2998 6.3501 7.0498 6.1001 6.7498 6.1001Z"
        fill={fill}
      />
      <path
        d="M6.7498 11.3501C6.4498 11.3501 6.1748 11.6001 6.1748 11.9251V12.0501C6.1748 12.3501 6.4248 12.6251 6.7498 12.6251C7.0748 12.6251 7.2998 12.3751 7.2998 12.0501V11.9251C7.2998 11.6001 7.0498 11.3501 6.7498 11.3501Z"
        fill={fill}
      />
    </svg>
  );
}
